import { describePlans, duplicateMemberKey, kindLabel } from './util';
import type { DuplicateClusterCardProps } from './types';

// One cluster of near-identical names across floor plans, unified to a single
// editable canonical spelling; each member can be excluded from the unify.
export const DuplicateClusterCard = ({
  cluster,
  clusterIndex,
  canonical,
  acceptedMemberKeys,
  onEditCanonical,
  onToggleMember,
}: DuplicateClusterCardProps) => (
  <div className="syntax-cluster">
    <div className="syntax-cluster-head">
      <span className="syntax-kind">{kindLabel(cluster.kind)}</span>
      <span className="syntax-cluster-arrow">unify to</span>
      <input
        className="syntax-target-input"
        value={canonical}
        onChange={(event) => onEditCanonical(clusterIndex, event.target.value)}
      />
    </div>
    {cluster.reason && <div className="syntax-reason">{cluster.reason}</div>}
    <div className="syntax-cluster-members">
      {cluster.members.map((member, memberIndex) => {
        const memberKey = duplicateMemberKey(clusterIndex, memberIndex);
        const isCanonical = member.name === canonical.trim();
        return (
          <label key={memberKey} className="syntax-member">
            <input
              type="checkbox"
              checked={acceptedMemberKeys.has(memberKey) && !isCanonical}
              disabled={isCanonical}
              onChange={() => onToggleMember(memberKey)}
            />
            <span className={isCanonical ? 'syntax-member-canonical' : 'syntax-member-name'}>
              {member.name}
            </span>
            <span className="syntax-member-plans">{describePlans(member.occurrences)}</span>
          </label>
        );
      })}
    </div>
  </div>
);
